var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardChart1 = function SvgCardChart1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 66,
    viewBox: "0 0 153 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 51.0469L55.6856 16.3369L76.9281 45.9769L131 12.0469",
    stroke: "black",
    strokeWidth: 7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 64.0469L55.6856 29.3369L76.9281 58.9769L131 25.0469",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeDasharray: "5 5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.859 36.5L151.359 4",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeDasharray: "5 5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.359 2L114.859 0L129.859 12L133.859 31.5L146.359 2Z",
    fill: "black"
  })));
};
export default SvgCardChart1;